import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class GpsService {

  API_URI = 'https://vigiliner.com.mx:1829/api';

  constructor(private http: HttpClient) { }
  /**
   * Nos trae toda la información de las unidades
  **/
  getTodos() {
    return this.http.get<any[]>(`${this.API_URI}/gps`);
  }
  getGps() {
    return this.http.get<any[]>(`${this.API_URI}/gpss`);
  }
  /**
   * Para enviar comando a las unidades
   * @param id Clave unica del gps
   * @param tipo Tipo de comando a enviar
  **/
  comando(id: string, tipo: string) {
    return this.http.get<Object>(`${this.API_URI}/comando/${id}/${tipo}`);
  }
  /**
   * Para obtener la direccion
   * @param lat Latitud del gps
   * @param lat Longitud del gps
   * @param punto Numero del punto en reporte
  **/
  direccion(lat: string, lon: string, punto: number) {
    return this.http.post(`${this.API_URI}/reversegeocoding`, {
      lat: lat,
      lon: lon,
      punto: punto
    });
  }
  /**
   * Listado de geocercas
  **/
  geocercas() {
    return this.http.get<any[]>(`${this.API_URI}/geocercas`);
  }
  /**
   * Listado de kmz
  **/
   kmz() {
    return this.http.get<any[]>(`${this.API_URI}/kmz`);
  }
  /**
   * Crear una nueva geocerca
   * @param json
   * @param nombre Nombre de la geocerca
   * @param color Color asignado
  **/
  nuevaGeocerca(json, nombre, color) {
    return this.http.post<Object>(`${this.API_URI}/nuevageocerca`, {
      json: json,
      nombre: nombre,
      color: color,
    });
  }
  /**
   * Actualizar unidad
   * @param json
   * @param id Clave unica de geocerca
  **/
  actualizarGeocerca(json, id) {
    return this.http.post<Object>(`${this.API_URI}/actualizargeocerca`, {
      json: json,
      id: id
    });
  }
  /**
   * Eliminar geocerca
   * @param id Clave unica de geocerca
   *
  **/
  eliminarGeocerca(id) {
    return this.http.post<Object>(`${this.API_URI}/eliminargeocerca`, {
      id: id
    });
  }
  /**
   * Para obtener datos de reporte de unidad
   * @param imei Identificador de GPS
   * @param start Fecha inicial
   * @param end Fecha final
  **/
  recorrido(imei: string, start: string, end: string) {
    return this.http.get<any[]>(`${this.API_URI}/reporte/${imei}/${start}/${end}`);
  }
  ultimoreporteERI(imei: string) {
    return this.http.post<Object>(`${this.API_URI}/ultimoreporteERI`, {imei});
  }

  getSensor(imei: string) {
    return this.http.post<Object>(`${this.API_URI}/gpsSensor`, {imei});
  }
}
